import './Responsive.scss';

const Responsive = () => {
    return <div className="responsive">Giao diện responsive đang trong quá trình phát triển</div>;
};

export default Responsive;
